import FaqCategory from ".";

export const faqCategoryRoutes = () => [
  {
    path: "/admin/faqs-categories",
    component: FaqCategory,
    layout: "admin",
    routeType: "admin",
    title: "FAQ Management",
  },
];
